import { useControls } from 'leva';
import { useRef } from 'react';

export default function ModuloPanel({ index, onChange }) {
  const state = useRef({
    larghezza: 60,
    ha_foro: false,
    foro_larghezza: 40,
    foro_profondita: 40,
    foro_radius: 5,
  });

  // Captured once by the factory — safe because all dependencies are stable refs/memoized props
  const update = (key, value) => {
    state.current = { ...state.current, [key]: value };
    onChange(index, { ...state.current });
  };

  useControls(`Modulo ${index}`, () => ({
    larghezza: {
      value: 60, min: 10, max: 300, step: 1, label: 'Larghezza (cm)',
      onChange: (v) => update('larghezza', v),
    },
    ha_foro: {
      value: false, label: 'Ha foro',
      onChange: (v) => update('ha_foro', v),
    },
    foro_larghezza: {
      value: 40, min: 10, max: 200, step: 1, label: 'Larghezza foro',
      onChange: (v) => update('foro_larghezza', v),
    },
    foro_profondita: {
      value: 40, min: 10, max: 50, step: 1, label: 'Profondità foro',
      onChange: (v) => update('foro_profondita', v),
    },
    foro_radius: {
      value: 5, min: 0, max: 20, step: 0.5, label: 'Radius foro',
      onChange: (v) => update('foro_radius', v),
    },
  }));

  return null;
}
